import React, { createContext } from 'react';

const SettledWindowTransactionsContext = createContext();

export default SettledWindowTransactionsContext;